import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LayoutDashboard, Cpu, Database, 
// Globe, // LANGUAGES DISABLED
// FileText, // PLAYBOOKS DISABLED
Target, Gift, BarChart3, Settings, Palette, FileText, Key } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';
const navItems = [
    { id: 'dashboard', icon: LayoutDashboard, labelKey: 'dashboard' },
    { id: 'ai-providers', icon: Cpu, labelKey: 'aiProviders' },
    { id: 'rag', icon: Database, labelKey: 'rag' },
    // PLAYBOOKS DISABLED { id: 'playbooks', icon: FileText, labelKey: 'playbooks' },
    { id: 'topics', icon: Target, labelKey: 'topics' },
    { id: 'promotions', icon: Gift, labelKey: 'promotions' },
    { id: 'analytics', icon: BarChart3, labelKey: 'analytics' },
    { id: 'analytics-settings', icon: Settings, labelKey: 'analyticsSettings' },
    { id: 'appearance', icon: Palette, labelKey: 'appearance' },
    { id: 'logs', icon: FileText, labelKey: 'logs' },
    { id: 'license', icon: Key, labelKey: 'license' },
];
// Inline styles for WordPress CSS isolation
const styles = {
    sidebar: {
        width: '260px',
        backgroundColor: '#ffffff',
        borderRight: '1px solid #e5e7eb',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    logoContainer: {
        height: '64px',
        padding: '0 20px',
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid #e5e7eb',
    },
    logoWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },
    logoImage: {
        width: '32px',
        height: '32px',
        objectFit: 'contain',
    },
    logoText: {
        fontWeight: 700,
        color: '#111827',
        fontSize: '16px',
    },
    nav: {
        flex: 1,
        padding: '20px 0',
        overflowY: 'auto',
    },
    navItem: {
        width: '100%',
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        position: 'relative',
        textAlign: 'left',
        transition: 'background-color 0.15s ease',
    },
    navItemActive: {
        backgroundColor: '#eef2ff',
        color: '#6366f1',
    },
    navItemInactive: {
        backgroundColor: 'transparent',
        color: '#374151',
    },
    navItemHover: {
        backgroundColor: '#f9fafb',
    },
    activeIndicator: {
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: '4px',
        borderRadius: '0 4px 4px 0',
        backgroundColor: '#6366f1',
    },
    navIcon: {
        width: '20px',
        height: '20px',
    },
    navLabel: {
        fontWeight: 500,
        fontSize: '14px',
    },
    version: {
        padding: '20px',
        borderTop: '1px solid #e5e7eb',
        fontSize: '12px',
        color: '#6b7280',
    },
};
/**
 * Admin sidebar navigation component
 * Uses inline styles for WordPress CSS isolation
 */
export function AdminSidebar({ currentPage, onNavigate, version = '1.0.0' }) {
    const { t, isRTL, direction } = useTranslation();
    // RTL-aware sidebar styles
    const sidebarStyles = {
        ...styles.sidebar,
        ...(isRTL ? { borderLeft: '1px solid #e5e7eb', borderRight: 'none' } : {})
    };
    const activeIndicatorStyles = {
        ...styles.activeIndicator,
        ...(isRTL ? { right: 0, left: 'auto', borderRadius: '4px 0 0 4px' } : {})
    };
    return (_jsxs("div", { dir: direction, style: sidebarStyles, children: [_jsx("div", { style: styles.logoContainer, children: _jsxs("div", { style: styles.logoWrapper, children: [_jsx("img", { src: "/wp-content/plugins/woo-ai-chatbot-pro/assets/images/logo.png", alt: "WooCommerce AI Assistant", style: styles.logoImage }), _jsx("span", { style: styles.logoText, children: "WooAI Assistant" })] }) }), _jsx("nav", { style: styles.nav, role: "navigation", "aria-label": "Main navigation", children: navItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = currentPage === item.id;
                    return (_jsxs("button", { onClick: () => onNavigate(item.id), style: {
                            ...styles.navItem,
                            ...(isActive ? styles.navItemActive : styles.navItemInactive),
                        }, "aria-current": isActive ? 'page' : undefined, role: "menuitem", onMouseEnter: (e) => {
                            if (!isActive) {
                                e.currentTarget.style.backgroundColor = '#f9fafb';
                            }
                        }, onMouseLeave: (e) => {
                            if (!isActive) {
                                e.currentTarget.style.backgroundColor = 'transparent';
                            }
                        }, children: [isActive && (_jsx("div", { style: activeIndicatorStyles, "aria-hidden": "true" })), _jsx(Icon, { style: {
                                    ...styles.navIcon,
                                    color: isActive ? '#6366f1' : '#374151',
                                }, "aria-hidden": "true" }), _jsx("span", { style: {
                                    ...styles.navLabel,
                                    color: isActive ? '#6366f1' : '#374151',
                                }, children: t(item.labelKey) })] }, item.id));
                }) }), _jsx("div", { style: styles.version, children: t('version', { version }) })] }));
}
